import { useEffect, useState } from 'react';

/**
 * Whether the Google Maps script has loaded. It is loaded async (public/index.html),
 * so `window.google` may not exist when a component mounts: false until
 * `window.googleMapsReady` resolves, then the component renders again with true.
 */
export const useGoogleMapsReady = (): boolean => {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let active = true;

    window.googleMapsReady.then(() => {
      if (active) {
        setReady(true);
      }
    });

    return () => {
      active = false;
    };
  }, []);

  return ready;
};
